<template>
  <div v-if="footerSubmenuLinks" class="submenu is-flex">
    <div v-for="(link, index) in footerSubmenuLinks" :key="index">
      <VuepalLink :to="link.href" class="has-text-white is-size-7">
        {{ link.label }}
      </VuepalLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const { footerSubmenuLinks } = useInitData()
</script>

<style scoped lang="scss">
.submenu {
  justify-content: space-between;
}
</style>
